module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/kycplans/kycplans.component.css
// module id = ./src/app/kycplans/kycplans.component.css
// module chunks = main